import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button, DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';
import * as actions from '../../actions/notificaciones';
import {api, request, API_URL} from '../../actions/_request';

import Alerta from './alerta';



class Notificaciones extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

        };


    }

    componentDidMount() {
     
    }

    render() {
      let lista_alerta=this.props.notificaciones.data;
       // console.log('lista_alerta---->',lista_alerta) 
      let n_alertas =this.props.notificaciones.data.length;
      // console.log('n_alertas---->',n_alertas)
        let top=window.screen.height;
      if(n_alertas==1)
        top=window.screen.height-200;
      if(n_alertas>1)
        top=window.screen.height-((n_alertas*50))-200;
        return(
             <div className="notificaciones_flotantes" style={{ 'top':top+'px'}}>

              {
                lista_alerta.map((item, i) => 
                  <Alerta key={i} mensaje={item.mensaje} tipo={item.tipo} creacion={item.creacion}/>
               )
              }
             
              
                

             </div>
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        notificaciones : state.notificaciones,
    }
};

export default connect(mapStateToProps, actions)(Notificaciones)


// WEBPACK FOOTER //
// ./src/components/notificaciones/notificaciones.js